import { AccountId, ContractId, TokenId, TransactionId } from "@hashgraph/sdk";
import { WalletInterface } from "../walletInterface";
import { ContractFunctionParameterBuilder } from "../contractFunctionParameterBuilder";
import { hashPackService } from "./hashPackService";

class HashPackWalletService implements WalletInterface {
  async executeContractFunction(
    contractId: ContractId,
    functionName: string,
    functionParameters: ContractFunctionParameterBuilder,
    gasLimit: number
  ): Promise<any> {
    console.log('Executing contract function:', {
      contractId: contractId.toString(),
      functionName,
      gasLimit
    });

    // Delegate to the real HashPack service, converting ContractId to string
    return await hashPackService.executeContractFunction(
      contractId.toString(),
      functionName,
      functionParameters,
      gasLimit
    );
  }

  disconnect(): void {
    console.log('Disconnecting from HashPack');
  }

  async transferHBAR(toAddress: AccountId, amount: number): Promise<TransactionId | string | null> {
    console.log('Transferring HBAR:', { toAddress: toAddress.toString(), amount });
    return 'mock-transaction-id';
  }

  async transferFungibleToken(
    toAddress: AccountId,
    tokenId: TokenId,
    amount: number
  ): Promise<TransactionId | string | null> {
    console.log('Transferring fungible token:', { toAddress: toAddress.toString(), tokenId: tokenId.toString(), amount });
    return 'mock-transaction-id';
  }

  async transferNonFungibleToken(
    toAddress: AccountId,
    tokenId: TokenId,
    serialNumber: number
  ): Promise<TransactionId | string | null> {
    console.log('Transferring NFT:', { toAddress: toAddress.toString(), tokenId: tokenId.toString(), serialNumber });
    return 'mock-transaction-id';
  }

  async associateToken(tokenId: TokenId): Promise<TransactionId | string | null> {
    console.log('Associating token:', tokenId.toString());
    return 'mock-transaction-id';
  }
}

export const hashPackWallet = new HashPackWalletService();